import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate, Button, showNotification, refreshView as refreshViewAction } from 'react-admin';
import compose from 'recompose/compose';

import request from '../../../../network/request';
import resourceConfig from './config';
import checkDocumentBeforeSend from '../../../../utils/checkDocumentBeforeSend';
import download from 'downloadjs';

class SendOrderButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: props.record.path,
      executing: false,
    };
  }

  handleClick = async () => {
    const { showNotification, record, refreshView, translate } = this.props;

    if (!checkDocumentBeforeSend(record, { showNotification, translate })) {
      return;
    }

    this.setState({
      executing: true,
    });

    const { id, path } = record;
    let data = {
      docId: id,
      path: path
    };
    let response = null;
    let url = '/admin/export_file/load';
    try {
      response = await request({
        apiService: 'shoes',
        path: url,
        urlParams: data,
        method: 'GET',
        responseType: 'blob',
      });
      if (response.ok) {
        let fileName = 'load';
        let mimeType = null
        if (data.path) {
          const pathParts = data.path.split('/')
          fileName = pathParts[pathParts.length - 1]
          // TODO: check mimetype
        }
        download(response.data, fileName, mimeType);
      }
    } catch (e) {
      console.error(e);
    }
    if (response === null || !response.ok) {
      showNotification(`resources.${resourceConfig.name}.sendDoc.errorMessage`, 'error');
    } else {
      showNotification(`resources.${resourceConfig.name}.sendDoc.successMessage`, 'success');
    }
  };

  render() {
    return (
      <Button
        label={`resources.${resourceConfig.name}.sendDoc.action`}
        disabled={this.state.path==null}
        onClick={this.handleClick}
      />
    );
  }
}

export default compose(
  translate,
  connect(undefined, {
    showNotification,
    refreshView: refreshViewAction,
  }),
)(SendOrderButton);
